import { Button } from '@material-ui/core';
import * as lib from '~/dependencies';

export const OpenButton = lib.styled(Button)`
  position: absolute !important;
  top: 20px !important;
  right: 8px !important;
  padding: 2px 5px 2px 5px !important;
  border-radius: 10px !important;
  font-size: 10px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  background-color: #d1f7d8 !important;
`;
